import React, { useEffect, useMemo, useState,useContext } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Paper,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../Components/dashboard";
import axios from "axios";
import { URL as BASE_URL } from "../config";
const themeColor = "#ff002b";

const SongSubTypeList = () => {
  const [tableLoading, setTableLoading] = useState(false);
const { setLoading } = useContext(LoaderContext);
  const [dataSource, setDataSource] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(1);
  const [mainTypes, setMainTypes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
  let isMounted = true;
  const startTime = Date.now();

  setLoading(true); 

  const fetchData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/songmaintype`);
      const data = Array.isArray(res.data?.data) ? res.data.data : [];
      if (isMounted) setDataSource(data);
    } catch (err) {
      console.error(err);
      if (isMounted) setDataSource([]);
    } finally {
      const elapsed = Date.now() - startTime;
      const remaining = 1500 - elapsed;

      setTimeout(() => {
        if (isMounted) {
          setLoading(false); 
        }
      }, remaining > 0 ? remaining : 0);
    }
  };

  fetchData();

  return () => {
    isMounted = false;
  };
}, []);

  const fetchData = async () => {
     const startTime = Date.now();
    setTableLoading(true);
    try {
    
      const mainRes = await axios.get(`${BASE_URL}/songmaintype`);
      const activeMainTypes = mainRes.data.data.filter(m => m.isActive === 1);
      setMainTypes(activeMainTypes);

     
      const subRes = await axios.get(`${BASE_URL}/songsubtype`);
      const subTypes = Array.isArray(subRes.data.data) ? subRes.data.data : [];

      const mappedSubTypes = subTypes.map(sub => ({
        ...sub,
        mainTypeName:
          activeMainTypes.find(m => m.mainTypeId === sub.fkMainTypeId)?.mainTypeName || "",
      }));

      setDataSource(mappedSubTypes);
    } catch (err) {
      console.error("Failed to fetch sub types:", err);
      setDataSource([]);
    }
    finally {
      const elapsed = Date.now() - startTime;
      const minDelay = 1500;
      const remaining = minDelay - elapsed;

      setTimeout(() => {
        setTableLoading(false);
      }, remaining > 0 ? remaining : 0);
    }
  };

 
  const handleEdit = (id) => {
    navigate(`/dashboard/subtype/${id}`);
  };

 
  const handleAddNew = () => {
    navigate(`/dashboard/subtype`);
  };

 
 const columns = useMemo(
  () => [
    {
      accessorKey: "actions",
      header: "Action",
        size: 35,
  minSize: 35,
  maxSize: 40,
      Cell: ({ row }) => (
        <IconButton
          size="small"
          onClick={() => handleEdit(row.original.subTypeId)}
          sx={{
            color: themeColor,
            backgroundColor: "#ffe6e9",
            "&:hover": { backgroundColor: "#ffe6e9" },
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ),
    },
    { accessorKey: "subTypeId", header: "ID", size: 50 },
    { accessorKey: "subTypeName", header: "Sub Type Name", size: 220,Cell: ({ cell }) => cell.getValue() || "-"  },
    { accessorKey: "mainTypeName", header: "Main Type", size: 150,Cell: ({ cell }) => cell.getValue() || "-"  },
    {
      accessorKey: "subTypePhoto", 
      header: "Image",
      size: 100,
      Cell: ({ cell }) =>
        cell.getValue() ? (
          <img
            src={`${BASE_URL}${cell.getValue()}`}
            alt="img"
            style={{
              width: 50,
              height: 35,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #ddd",
            }}
          />
        ) : (
          "-"
        ),
    },
    {
      accessorKey: "isActive",
      header: "Status",
      size: 100,
      Cell: ({ cell }) =>
        cell.getValue() === 1 ? (
          <Box
            sx={{
              px: 1.2,
              py: 0.3,
              bgcolor: "#e8f5e9",
              color: "#2e7d32",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 600,
              width: "fit-content",
            }}
          >
            Active
          </Box>
        ) : (
          <Box
            sx={{
              px: 1.2,
              py: 0.3,
              bgcolor: "#ffebee",
              color: "#c62828",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 600,
              width: "fit-content",
            }}
          >
            Inactive
          </Box>
        ),
    },
  ],
  []
);


 
  const filteredData = useMemo(() => {
    if (!Array.isArray(dataSource)) return [];
    return [...dataSource]
      .reverse()
      .filter(
        (item) =>
          (item.isActive ?? 0) === statusFilter &&
          Object.values(item || {})
            .join(" ")
            .toLowerCase()
            .includes(globalFilter.toLowerCase())
      );
  }, [dataSource, globalFilter, statusFilter]);

  return (
    <Box sx={{ p: { xs: 0.1, md: 1 } }}>
      <Paper elevation={4} sx={{ p: 2, borderRadius: 3 }}>
       
        <Box sx={{ display: "flex", justifyContent: "center", mt: 1.5, mb: 1.8 }}>
          <Box
            sx={{
             background: `linear-gradient(90deg, ${themeColor}, #ff6a6a)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)"

            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 900,
                color: "#fff",
                letterSpacing: "0.7px",
                textTransform: "uppercase",
              }}
            >
              Sub Types
            </Typography>
          </Box>
        </Box>

       
        <Divider
          sx={{
            mb: 2.2,
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
            borderRadius: 5,
          }}
        />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2.5 }}
        >
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="contained"
              onClick={handleAddNew}
              sx={{
                borderRadius: 20,
                px: 2.2,
                minHeight: 32,
                textTransform: "none",
                backgroundColor: themeColor,
                color: "#fff",
              }}
            >
              Add New
            </Button>

            {[{ label: "Active", value: 1 }, { label: "Inactive", value: 0 }].map(
              (btn) => (
                <Button
                  key={btn.value}
                  size="small"
                  variant={statusFilter === btn.value ? "contained" : "outlined"}
                  onClick={() => setStatusFilter(btn.value)}
                  sx={{
                    borderRadius: 20,
                    px: 2.2,
                    minHeight: 32,
                    textTransform: "none",
                    backgroundColor:
                      statusFilter === btn.value ? themeColor : "#fff",
                    color: statusFilter === btn.value ? "#fff" : themeColor,
                    borderColor: themeColor,
                  }}
                >
                  {btn.label}
                </Button>
              )
            )}
          </Stack>

          <TextField
            size="small"
            placeholder="Search sub types..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: themeColor, fontSize: 18 }} />
                </InputAdornment>
              ),
            }}
             sx={{
              width: { xs: "100%", sm: 240 },
              "& .MuiOutlinedInput-root": {
                borderRadius: 20,
                height: 34,
                "& fieldset": { borderColor: "#454444" },
                "&:hover fieldset": {
                  borderColor: themeColor,
                  boxShadow: `0 0 0 2px ${themeColor}22`,
                },
                "&.Mui-focused fieldset": {
                  borderColor: themeColor,
                  boxShadow: `0 0 0 3px ${themeColor}33`,
                },
              },
            }}
          />
        </Stack>

       <MaterialReactTable
                 columns={columns}
                 data={filteredData}
                 state={{ isLoading: tableLoading }}
                
                 enableTopToolbar={false}
                 enableColumnActions={false}
                 enableDensityToggle={false}
                 enableFullScreenToggle={false}
                 enableColumnFilters={false}
                 enableGlobalFilter={false}
                 enableHiding={false}
               
                 muiTablePaperProps={{
                   sx: {
                     boxShadow: "none",
                     mt: 0.5,
                   },
                 }}
               
                 
                 muiTableContainerProps={{
                   sx: {
                     maxHeight: { xs: "55vh", sm: "none" },
                     "&::-webkit-scrollbar": {
                       height: "6px",
                     },
                     "&::-webkit-scrollbar-track": {
                       background: "transparent",
                     },
                     "&::-webkit-scrollbar-thumb": {
                       backgroundColor: "#cfcfcf",
                       borderRadius: "4px",
                     },
                     "&::-webkit-scrollbar-thumb:hover": {
                       backgroundColor: "#b0b0b0",
                     },
                   },
                 }}
               
                 muiTableHeadCellProps={{
                   sx: {
                     backgroundColor: "#ffe6e9",
                     fontWeight: 700,
                     fontSize: { xs: "12px", sm: "14px" },
                     py: { xs: 0.8, sm: 1.2 },
                     whiteSpace: "nowrap",
                   },
                 }}
               
               
                 muiTableBodyRowProps={{
                   sx: {
                     "& td": {
                       fontSize: { xs: "11px", sm: "14px" },
                       py: { xs: 0.5, sm: 1 },
                       whiteSpace: "nowrap",
                     },
                     "&:hover": {
                       backgroundColor: "#fff8e1",
                     },
                   },
                 }}
               
                
                 initialState={{
                   pagination: {
                     pageSize: 50,
                     pageIndex: 0,
                   },
                 }}
               />      </Paper>
    </Box>
  );
};

export default SongSubTypeList;
